import React from 'react';

import { Button, Image, Tooltip } from 'antd';
import styled from 'styled-components';

const DEFAULT_ICON = '/icons/checklist.svg';
const DEFAULT_SELECTED_ICON = '/icons/checklist-selected.svg';

const StyledButton = styled(Button)<{
  $active: boolean;
  $activeBackgroundColor?: string;
  $inactiveBackgroundColor?: string;
  $padding: number;
}>`
  padding: ${({ $padding }) => $padding}px;
  border: solid 1px ${({ $active }) => ($active ? 'var(--button-blue)' : 'var(--line-gray)')};
  height: 36px;
  width: 36px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${({ $active, $activeBackgroundColor, $inactiveBackgroundColor }) =>
    $active ? $activeBackgroundColor ?? 'white' : $inactiveBackgroundColor ?? 'white'};
  border-radius: 4px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);

  &&.ant-btn > span {
    display: flex;
  }

  &&.ant-btn[disabled],
  &&.ant-btn:disabled {
    cursor: default;
  }
`;

type Props = {
  active: boolean;
  onClick: () => void;
  activeBackgroundColor?: string;
  className?: string;
  dataTestId?: string;
  disabled?: boolean;
  inactiveBackgroundColor?: string;
  selectedIconSrc?: string;
  tooltipTitle?: React.ReactNode;
  wrapTooltip?: boolean;
};

const BulkSelectToggleButton = ({
  active,
  activeBackgroundColor,
  className,
  dataTestId,
  disabled,
  inactiveBackgroundColor,
  onClick,
  selectedIconSrc = DEFAULT_SELECTED_ICON,
  tooltipTitle,
  wrapTooltip = Boolean(tooltipTitle),
}: Props) => {
  const button = (
    <StyledButton
      $active={active}
      $activeBackgroundColor={activeBackgroundColor}
      $inactiveBackgroundColor={inactiveBackgroundColor}
      $padding={activeBackgroundColor ? 7 : 0}
      className={className}
      disabled={disabled}
      onClick={onClick}
      data-test-id={dataTestId}
    >
      <Image src={active ? selectedIconSrc : DEFAULT_ICON} width={24} height={24} preview={false} />
    </StyledButton>
  );

  if (!wrapTooltip || !tooltipTitle) {
    return button;
  }

  return (
    <Tooltip title={tooltipTitle}>
      <span>{button}</span>
    </Tooltip>
  );
};

export default BulkSelectToggleButton;
